import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  Button,
  Collapse,
  CardBody,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  Label,
  Row,
  Col
} from "reactstrap";

const TermsAndConditions = ({ onDataChange, data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [termsData, setTermsData] = useState(data || []);
  useEffect(() => {
    if (data && data.length > 0) {
      setTermsData(data);  // Update termsData when data becomes available
    }
  }, [data]);  // Runs whenever `data` updates

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const selectAll = () => {
    const updatedTerms = termsData?.map((term) => ({
      ...term,
      Checkbox: term.AskTerms === "-" ? false : true,
      VendorTerms: term.AskTerms === "-" ? "" : term.AskTerms
    }));
    setTermsData(updatedTerms);
  };

  const handleCheckboxChange = (termId, checked) => {
    setTermsData((prev) =>
      prev?.map((term) =>
        term.TermID === termId && term.AskTerms !== "-"
          ? { ...term, Checkbox: checked, VendorTerms: checked ? term.AskTerms : "" }
          : term
      )
    );
  };

  const handleVendorInputChange = (termId, value) => {
    setTermsData((prev) =>
      prev.map((term) =>
        term.TermID === termId ? { ...term, VendorTerms: value } : term
      )
    );
  };

  useEffect(() => {
    onDataChange(termsData);
  }, [termsData]);

  return (
    <div className="mt-4">
      <Card>
        <CardHeader>
          <Row className="justify-content-center">
            <Col md={3}>
              <Button
                color="primary"
                onClick={toggleAccordion}
                className="w-100 text-left"
              >
                Terms & Conditions
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <Collapse isOpen={isOpen}>
          <CardBody>
            <Button
              color="success"
              size="sm"
              className="mb-3"
              onClick={selectAll}
            >
              Accept All Terms
            </Button>

            <ListGroup className="mt-3">
              {termsData && termsData.map((requirement) => (
                <ListGroupItem key={requirement.TermID}>
                  <p className="text-muted mb-3">{requirement.TermsType}: {requirement.AskTerms}</p>
                  <FormGroup className="d-flex align-items-center gap-3">
                    <div className="d-flex align-items-center gap-2">
                      <Input
                        type="checkbox"
                        checked={requirement.AskTerms === "-" ? false : requirement.Checkbox || false}
                        onChange={(e) =>
                          handleCheckboxChange(requirement.TermID, e.target.checked)
                        }
                        className="form-check-input"
                        disabled={requirement.AskTerms === "-"}
                      />
                      <Label className="mb-0 text-dark">Agree</Label>
                    </div>

                    <Input
                      type="text"
                      placeholder="Vendor Input"
                      value={requirement.VendorTerms || ""}
                      onChange={(e) =>
                        handleVendorInputChange(requirement.TermID, e.target.value)
                      }
                      disabled={requirement.AskTerms !== "-" && requirement.Checkbox}
                      className={`form-control ${requirement.AskTerms !== "-" && requirement.Checkbox ? "bg-light text-muted" : ""}`}
                    />
                  </FormGroup>
                </ListGroupItem>
              ))}
            </ListGroup>
          </CardBody>
        </Collapse>
      </Card>
    </div>
  );
};

export default TermsAndConditions;
